import React from 'react';
import metadata from 'libphonenumber-js/metadata.full.json';
import { getCountryCallingCode } from 'libphonenumber-js/max';
import country_names from './countries.json';

const CountryOptions = () => {
    const excluded_countries = Mobi2Go.UI.phone_number_excluded_countries || [
        '001',
    ];
    const display_priorities = Mobi2Go.UI
        .phone_number_country_display_priorities || {
        AU: 1,
        NZ: 2,
        US: 1,
    };

    const countries = Object.keys(metadata.countries)
        .filter(country => excluded_countries.indexOf(country) === -1)
        .sort((country_a, country_b) => {
            const country_a_priority = display_priorities[country_a] || 0;
            const country_b_priority = display_priorities[country_b] || 0;

            const priority_result = country_b_priority - country_a_priority;
            if (priority_result === 0) {
                const country_a_name = country_names[country_a];
                const country_b_name = country_names[country_b];
                return country_a_name.localeCompare(country_b_name);
            }
            return priority_result;
        });

    return countries.map(country_code => {
        const country_name = country_names[country_code];
        const country_calling_code = getCountryCallingCode(
            country_code,
            metadata
        );
        const display_text = `${country_name} (+${country_calling_code})`;
        return (
            <option value={country_code} key={country_code}>
                {display_text}
            </option>
        );
    });
};

export default CountryOptions;
